import Jump from 'jump.js'

function init () {
  const jumps = document.querySelectorAll('[data-jump]')

  if (!jumps.length) {
    return
  }

  Array.from(jumps).forEach(jump => {
    jump.addEventListener('click', (e) => {
      e.preventDefault()
      const el = jump.getAttribute('href')
      jumpTo(el)
    })
  })
}

function jumpTo (el) {
  Jump(el, {
    duration: 500,
    offset: -100
  })
}

export default init
